<template>
  <div class="edit">
    <!--顶部-->
    <header-nav :current="current"></header-nav>
    <div class="content" ref="content">
      <div class="box clearfix">
        <user-left :name="'order'"></user-left>
        <div class="user-right" ref="right">
          <div class="title-top">
            <span>购买记录</span>
          </div>
          <div class="a-over-h search-sort" style="display: flex;">
            <div class="search a-fl">
              <div class="a-fr a-over-h" style="height: 36px;width: 180px;border: solid #dbdbdb 1px;border-radius: 6px;">
                <input type="text" style="width: 150px;" v-model="keywords" placeholder="请输入搜索关键词"/>
              </div>
            </div>
            <el-date-picker style="width: 270px !important;height: 38px !important;border-radius: 6px;margin-left: 8px"
                            v-model="dates"
                            type="daterange"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
            </el-date-picker>

            <button class="search-btn" @click="searchFun">
              <img :src="btnImg" width="30px" alt="">
            </button>
          </div>
          <div class="table-box">
            <table>
              <tr class="a-ta-c">
                <!--<td class="tx-l">测评量表名称</td>-->
                <td style="text-align:left;width: 40%">量表</td>
                <td class="td-order">
                  购买次数
                  <template v-if="countOrder === 'desc'">
                    <img class="order-img" @click="changeOrder('count','asc')" :src="descIcon" alt="">
                  </template>
                  <template v-else-if="countOrder === 'asc'">
                    <img class="order-img" @click="changeOrder('count','')" :src="ascIcon" alt="">
                  </template>
                  <template v-else>
                    <img class="order-img" @click="changeOrder('count','desc')" :src="defaultOrder" alt="">
                  </template>
                </td>
                <td>
                  <div style="display: flex;align-items: end;justify-content: center">
                    <div>支付金额</div>
                    <template v-if="moneyOrder === 'desc'">
                      <img class="order-img" @click="changeOrder('money','asc')" :src="descIcon" alt="">
                    </template>
                    <template v-else-if="moneyOrder === 'asc'">
                      <img class="order-img" @click="changeOrder('money','')" :src="ascIcon" alt="">
                    </template>
                    <template v-else>
                      <img class="order-img" @click="changeOrder('money','desc')" :src="defaultOrder" alt="">
                    </template>
                  </div>
                </td>
                <td class="td-order">
                  购买时间
                  <template v-if="timeOrder === 'desc'">
                    <img class="order-img" @click="changeOrder('time','asc')" :src="descIcon" alt="">
                  </template>
                  <template v-else-if="timeOrder === 'asc'">
                    <img class="order-img" @click="changeOrder('time','')" :src="ascIcon" alt="">
                  </template>
                  <template v-else>
                    <img class="order-img" @click="changeOrder('time','desc')" :src="defaultOrder" alt="">
                  </template>
                </td>
              </tr>
              <template v-if="td_case.length > 0">
                <tr v-for="(item, index) in td_case" :key="index">
                  <td class="a-ta-c" style="text-align:left;">
                    {{item.title}}
                    <template v-if="item.edition.length > 0">
                      <span style="font-size: 12px">({{item.edition}})</span>
                    </template>
                  </td>
                  <td class="a-ta-c">
                    {{item.num}}
                  </td>
                  <td class="a-ta-c">{{item.order_amount}}</td>
                  <td class="a-ta-c">{{item.pay_time}}</td>
                </tr>
              </template>
              <template v-else>
                <tr v-if="td_case.length==0">
                  <td colspan="5" style="text-align: center">暂无数据</td>
                </tr>
              </template>
            </table>
            <div class="btn-box"  v-if="td_case.length!=0">
              <div @click="moreCallback(0)">上一页</div>
              <div @click="moreCallback(1)" style="margin-right: 15px;">下一页</div>
              <span>共{{listInfo.totalPage}}页</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--底部-->
    <footer-nav></footer-nav>
    <div id="printBox"></div>
  </div>
</template>

<script>
import HeaderNav from '@/components/HeaderNav'
import FooterNav from '@/components/FooterNav'
import MoreList from '@/components/MoreList'
import UserLeft from '@/components/UserLeft'
import searchBtnImg from '@/assets/img/search-btn.png'
import desc from '@/assets/img/order-desc.png'
import asc from '@/assets/img/order-asc.png'
import def from '@/assets/img/order-default.png'

export default {
  name: 'user',
  data() {
    return {
      current: 'user',
      td_case: [],
      sort: 'desc',
      descIcon:desc,
      ascIcon:asc,
      defaultOrder:def,
      timeOrder:'desc',
      countOrder:'',
      moneyOrder:'',
      keywords: '',
      page: 1,
      more: false,
      nodata: false,
      checkboxModel: [],
      checked: false,
      checkLength: '',
      listInfo: {},
      dates:'',
      options: [{
        value: '',
        label: '选择类型'
      },{
        value: '1',
        label: '增加'
      }, {
        value: '2',
        label: '扣除'
      }],
      type: '',
      btnImg:searchBtnImg
    }
  },
  methods: {
    searchFun: function () {
      this.getList()
    },
    checkedAll() {
      var _this = this
      if (this.checked) {//实现反选
        _this.checkboxModel = [];
      } else {//实现全选
        _this.checkboxModel = [];
        _this.td_case.forEach(function (item) {
          if (item.status == 2) {
            _this.checkboxModel.push(item.exam_id);
          }
        });
        _this.checkLength = _this.checkboxModel.length
      }
    },
    getList: function () {
      let params = {
        token: localStorage.getItem('token'),
        keyword: this.keywords,
        dates:this.dates,
        type:this.type,
        sort:{
          c_sort:this.countOrder,
          t_sort:this.timeOrder,
          m_sort:this.moneyOrder
        },
        page: 1,
        limit: 10
      }
      if (this.$route.query.id) {
        params.title_id = this.$route.query.id
      }
      this.$post('user/orders', params).then(res => {
        if (res.code === 1) {
          if (!res.data.totalCount) {
            this.nodata = true
            this.td_case = []
            // return false
          } else {
            this.nodata = false
          }
          this.td_case = res.data.listData
          this.listInfo = res.data
          if (res.data.listData.length < res.data.perPage) {
            this.more = false
          } else {
            this.more = true
          }
        } else {
          this.$layer.msg(res.msg)
          this.nodata = true
        }

      }).catch(response => {
        this.$layer.msg('网络异常，请稍后重试！')
        this.nodata = true
      })
    },
    moreCallback: function (way) {
      if (way == 0) {
        if (this.page <= 1) {
          this.$layer.msg('已经是第一页了！')
          return
        } else {
          this.page--
        }
      } else if (way == 1) {
        if (this.page >= parseInt(this.listInfo.totalPage)) {
          this.$layer.msg("最后一页了")
        } else {
          this.page++
        }
      }
      let params = {
        token: localStorage.getItem('token'),
        keyword: this.keywords,
        dates:this.dates,
        type:this.type,
        sort:{
          c_sort:this.countOrder,
          t_sort:this.timeOrder,
          m_sort:this.moneyOrder
        },
        page: this.page,
        limit: 10
      }

      if (this.$route.query.id) {
        params.title_id = this.$route.query.id
      }
      this.$post('user/orders', params).then(res => {
        if (res.code === 1) {
          this.td_case = res.data.listData
          this.listInfo = res.data

        } else {
          this.$layer.msg(res.msg)
        }
      }).catch(response => {
        this.$layer.msg('网络异常，请稍后重试！')
      })
    },
    changeOrder(field,sort){
      switch (field){
        case 'count':
          this.countOrder = sort
          break;
        case 'time':
          this.timeOrder = sort
          break;
        case 'money':
          this.moneyOrder = sort
          break;
      }
      this.getList()
    }
  },
  watch: {
    keywords() {
      // this.page = 1
      // this.getList()
    },
    'checkboxModel': {
      handler: function (val, oldVal) {
        if (this.checkboxModel.length === this.checkLength) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      },
      deep: true
    }
  },
  components: {
    HeaderNav,
    FooterNav,
    MoreList,
    UserLeft
  },
  mounted: function () {
    var h = document.documentElement.clientHeight || document.body.clientHeight
    this.$refs.content.style.minHeight = h - 124 + 'px'
    this.$refs.right.style.minHeight = h - 144 + 'px'
  },
  created() {
    this.title = this.$route.query.title
    this.getList()
  }
}
</script>

<style lang="less" scoped>
@import url('../assets/css/page/history');

.btn1-box {
  min-width: 60px;
  text-align: center;
}

.btn1-box span {
  color: #f39902;
  padding: 0 5px;
  cursor: pointer;
}

.btn1-box span:hover {
  text-decoration: underline;
}

.btn-box {
  text-align: right;
  margin: 60px 0px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  color: #f39902;
}

.btn-box div {
  color: #f39902;
  font-size: 16px;
  border-radius: 4px;
  margin: 0 5px;
  cursor: pointer;
  outline: medium;
}

.btn-box div:last-child {
  /*color:#333;*/
  margin-right: 10px;
}
.td-order{
  display: flex;
  align-items: end;
  justify-content: center;
}
.order-img{
  width: 20px;
  margin-left: 4px;
}
</style>
<style>
/**
.el-date-range-picker{
  width: 323px;
}
.el-date-range-picker__content{
  width: 100% !important;
}
.el-date-range-picker__content.is-left{
  border: none !important;
}
.el-date-range-picker .el-picker-panel__body {
  min-width: unset !important;
  width: 323px;
  display: flex;
  flex-direction: column;
}
 */
.today > div > span{
  color: #f39902 !important;
}
.el-date-table td.available:hover {
  color: #f39902 !important;
}
.el-date-table td.end-date span, .el-date-table td.start-date span {
  background-color: #f39902 !important;
}
.el-range-editor.is-active, .el-range-editor.is-active:hover, .el-select .el-input.is-focus .el-input__inner {
  border-color: #dbdbdb;
}
.el-select .el-input__inner:focus {
  border-color: #dbdbdb;
}
.el-select-dropdown__item.selected {
  color: #f39902;
  font-weight: 700;
}
.el-select > div > .el-input__inner{
  height: 38px !important;
  line-height: 38px !important;
  border-radius: 6px;
}
.search-btn{
  height: 38px;
  width: 70px;
  text-align: center;
  background-color: #f39902;
  border: none;
  border-radius: 6px;
  margin-left: 8px;
}
</style>
